<template>
    <div>
        <h1 class="header">{{$t("wm_lang_html_812024")}}</h1>
        <div class="audit-content audit-layout">
            <div
                v-for="item in recordInfoList"
                class="audit-line"
            >
                <label>{{item.label}}</label>
                <span>{{item.data}}</span>
            </div>
        </div>
        <h3 class="record-header audit-layout">{{$t("wm_lang_html_2d23c6")}}</h3>

        <div class="audit-layout">
            <el-table
                :data="tableData"
                size="small"
            >
                <el-table-column
                    prop="auditorUserEmail"
                    :label="$i18n.t('wm_lang_82da89')"
                    align="center"
                />
                <el-table-column
                    prop="result"
                    :label="$i18n.t('wm_lang_8beefb')"
                    width="140"
                    align="center"
                />
                <el-table-column
                    prop="memo"
                    align="center"
                    :label="$i18n.t('wm_lang_3b3190')"
                />
                <el-table-column
                    prop="date"
                    align="center"
                    :label="$i18n.t('wm_lang_e6f070')"
                    width="140"
                />
            </el-table>
        </div>

        <div class="record-header audit-content audit-layout">
            <div class="audit-line">
                <label>{{$t("wm_lang_html_fa8b0f")}}</label>
                <span>{{auditExpiredTime}}</span>
            </div>
            <div class="audit-line">
                <label>{{$t("wm_lang_html_0dee1e")}}</label>
                <span>{{auditResult}}</span>
            </div>
            <div v-if="isTestareaShow" class="audit-line">
                <label style="align-self: flex-end;">{{$t("wm_lang_html_78ad95")}}</label>
                <textarea cols="60" rows="6" v-model="additionalComments"/>
            </div>
            <div v-if="isTestareaShow" class="audit-line" style="margin: 16px 0;">
                <label />
                <el-button type="primary" @click="submit">{{btnText}}</el-button>
            </div>
        </div>
        <div v-if="timeout" class="audit-layout">{{$t("wm_lang_html_8c18cb")}}</div>
    </div>
</template>


<script>
    import xmail from '@/api/api';
    import axios from 'axios'
    import {sendMailErrorAlert} from '@/utils/sendMailAlert';
    import getErrorMsg from '@/language/getErrorMessage';
    export default {
        name: 'AuditList',
        data () {
            return {
                recordInfoList: [
                    {
                        label: this.$i18n.t('wm_lang_defd7b'),
                        data: ''
                    },
                    {
                        label: this.$i18n.t('wm_lang_7f9402'),
                        data: ''
                    },
                    {
                        label: this.$i18n.t('wm_lang_719156'),
                        data: ''
                    },
                    {
                        label: this.$i18n.t('wm_lang_df23a5'),
                        data: ''
                    },
                    {
                        label: this.$i18n.t('wm_lang_fd4cfa'),
                        data: ''
                    },
                    {
                        label: this.$i18n.t('wm_lang_25c9ea'),
                        data: ''
                    }

                ],
                tableData: [],
                additionalComments: '',
                auditExpiredTime: '',
                auditResult: '',
                submitData: {
                    userEmail: '',
                    auditLogId: '',
                    auditorPwd: '',
                    memo: '',
                    status: 1
                },
                isTestareaShow: false,
                btnText: this.$i18n.t('wm_lang_e61f2c'),
                timeout: false
            }
        },
        mounted() {
            this.getLogInfo()
        },
        methods: {
            getLogInfo() {
                const query = this.$route.query;
                const _this = this;

                query.status == '1' ? this.btnText = this.$i18n.t('wm_lang_e61f2c') : this.btnText = this.$i18n.t('wm_lang_7173f8');

                (function (api, enums, pms) {
                    let pm = pms.AuditMail.infoParamBuilder();
                    for (let key in query) {
                        pm[key] = query[key];
                    }
                    axios.get('/xmail/wm/v1/audit/log/info', {
                        params: pm
                    }).then(res => {
                        const {
                            auditLog = {},
                            auditorLog = {}
                        } = res.data.data;

                        const {
                            mailFrom = '',
                            mailTo = '',
                            mailDate = '',
                            subject = '',
                            auditType = '',
                            auditExpiredTime = '',
                            auditors = ''
                        } = auditLog;
                        _this.timeout = auditLog.status == 5;
                        // 发信人
                        _this.recordInfoList[0].data = mailFrom;

                        // 收信人
                        _this.recordInfoList[1].data = mailTo;

                        // 原发信时间
                        _this.recordInfoList[2].data = _this.$moment(mailDate).format('YYYY-MM-DD HH:mm:ss');

                        // 主题
                        _this.recordInfoList[3].data = subject;

                        // 审计人
                        _this.recordInfoList[5].data = auditors;

                        // 审计类型
                        switch(auditType) {
                            case 1:
                                _this.recordInfoList[4].data = _this.$i18n.t('wm_lang_ce219a');
                                break;
                            case 2:
                                _this.recordInfoList[4].data = _this.$i18n.t('wm_lang_47b0da');
                                break;
                        }

                        // 审核时限
                        if (auditExpiredTime) {
                            _this.auditExpiredTime = _this.$moment(auditExpiredTime).format('YYYY-MM-DD HH:mm:ss');
                        }
                        else {
                            _this.auditExpiredTime = _this.$i18n.t('wm_lang_bc4364');
                        }
                        let result = '';
                        switch (auditLog.status) {
                            case 1:
                                result = _this.$i18n.t('wm_lang_e61f2c');
                                break;
                            case 2:
                                result = _this.$i18n.t('wm_lang_7173f8');
                                break;
                            case 3:
                                result = _this.$i18n.t('wm_lang_b720a6');
                                break;
                            case 4:
                                result = _this.$i18n.t('wm_lang_b87f22') + getErrorMsg(auditLog.errorCode).replace("{invalidAddress}", '') + _this.$i18n.t('wm_lang_0611d8');
                                break;
                            case 5:
                                result = _this.$i18n.t('wm_lang_91e9e8');
                                break;
                        }
                        _this.auditResult = result;

                        const {
                            auditorUserEmail = '',
                            auditorTime = '',
                            status = '',
                            memo = '',
                            auditLogId = '',
                            auditorPwd = ''
                        } = auditorLog;

                        // 审计记录
                        result = '';
                        switch(status) {
                            case 1:
                                result = _this.$i18n.t('wm_lang_e61f2c');
                                break;
                            case 2:
                                result = _this.$i18n.t('wm_lang_7173f8');
                                break;
                            case 3:
                                result = _this.$i18n.t('wm_lang_b720a6');
                                break;
                        }
                        _this.isTestareaShow = auditLog.status == 3;
                        _this.tableData.push({
                            date: (auditorTime && _this.$moment(auditorTime).format('YYYY-MM-DD HH:mm:ss')) || '',
                            auditorUserEmail,
                            memo,
                            result
                        })

                        // 提交数据
                        _this.submitData.userEmail = auditorUserEmail
                        _this.submitData.auditLogId = auditLogId
                        _this.submitData.auditorPwd = auditorPwd
                        _this.submitData.status = query.status
                    })
                })(xmail.api, xmail.enums, xmail.pms);
            },
            submit() {
                const _this = this;

                (function (api, enums, pms) {
                    let pm = pms.AuditMail.auditMailParamBuilder();
                    pm = Object.assign({}, _this.submitData, {
                        memo: _this.additionalComments
                    })
                    api.AuditMail.auditMail(pm, (res) => {
                        console.log(res);
                        if (res.data.code == 0) {
                            _this.$alert(
                                `${_this.$i18n.t('custom_lang_0007')}'${_this.btnText}'！`,
                                `${_this.$i18n.t('wm_lang_c45357')}`,
                                {
                                    confirmButtonText: _this.$i18n.t('wm_lang_38cf16'),
                                    callback: () => {
                                        location.reload();
                                    }
                                }
                            )
                        }
                        else {
                            if ((res.data.code >= 2051 && res.data.code <= 2060) || (res.data.code >= 2851 && res.data.code <= 2900)) {
                                sendMailErrorAlert(res);
                            }
                        }
                    })
                })(xmail.api, xmail.enums, xmail.pms);
            }
        }
    }
</script>


<style scoped lang="scss">
.header {
    margin-top:0px;
    padding: 18px;
    background-image: linear-gradient(#c2e5f5, #fff 62%);
}
.audit-content .audit-line {
    display: flex;
    margin: 4px 0;

    label {
        width: 20em;
        text-align: right;
        align-self: center;
    }
    span {
        flex: 1;
        align-self: flex-end;
    }
    textarea {
        border: .1px solid #DCDFE6;
    }
}
.audit-layout {
    padding: 0 18px;
}
.record-header {
    margin-top: 32px;
}
</style>



// WEBPACK FOOTER //
// src/components/views/setBox/auditList.vue